// extracted by css-extract-rspack-plugin
export default {"header":"Header__header--TxZwD","content":"Header__content--Ns4Xu"};